<template>
  <b-modal
    id="modal-nuevo-pago"
    centered
    title="Nueva Configuración"
    ok-title="GUARDAR"
    cancel-title="CANCELAR"
    cancel-variant="outline-secondary"
    v-model="$store.state.someVariables.showNewConfigPago"
  >
    <b-row>
      <b-col md="12">
        <v-select
          placeholder="Seleccionar Categoria"
          :clearable="true"
          :options="listCategorias"
          v-model="dataPagoConfig.categoria"
          class="mb-1 mt-1 select-size-sm"
        />
      </b-col>
      <b-col md="12">
        <v-select
          placeholder="Seleccionar Forma Pago"
          :clearable="true"
          :options="listFormas"
          v-model="dataPagoConfig.formaPago"
          class="mb-1 mt-1 select-size-sm"
        />
      </b-col>
      <b-col md="12">
        <b-form>
          <div class="form-label-group">
            <b-form-input
              id="floating-titulo"
              placeholder="Ingrese Valor *"
              v-model="dataPagoConfig.valor"
              type="number"
              class="mt-1"
            />
            <label for="floating-titulo">Valor</label>
          </div>
        </b-form>
      </b-col>
    </b-row>

    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="uploadNoticia"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
          <span>Espere..</span>
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px ;z-index:100"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BModal,
  BForm,
  BFormInput,
  // BFormGroup,
  //   BFormInvalidFeedback,
  //   BFormValidFeedback,
  // BFormTextarea,
  // BFormRadio,
  // BFormFile,
  BButton,
  BSpinner,
  BAlert,
  BRow,
  BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
// import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  URL,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    // BFormGroup,
    // BFormInvalidFeedback,
    // BFormValidFeedback,
    // BFormTextarea,
    // BFormRadio,
    // BFormFile,
    BButton,
    BSpinner,
    BAlert,
    // flatPickr,
    vSelect,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    dataPagoConfig: Object,
    listCategorias: Array,
    listFormas: Array,
  },
  setup(props, { emit }) {
    const tieneErrorTitulo = ref(null)
    const mensajeErrorTitulo = ref('')
    const selected = ref(null)
    const inputTitulo = ref('')
    const croppaFoto = ref({})
    const file = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const variante = ref('danger')
    const showLoading = ref(false)
    const hasError = ref(false)
    const fileModel = ref(null)
    const capturada = ref(false)
    const { postApiFormData } = apiCall()
    const dataNoticia = ref({
      titulo: '',
      link: '',
      descripcion: '',
      es_video: 'n',
      id_torneo: '0',
    })

    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }

    function resetForm() {
      dataNoticia.value = {
        titulo: '',
        link: '',
        descripcion: '',
        es_video: 'n',
        id_torneo: '0',
      }
      capturada.value = false
      fileModel.value = null
      const canvas = document.getElementById('canvasFotoVideo')
      if (canvas != null) {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
        const videoNode = document.querySelector('video')
        videoNode.src = null
      }
      selected.value = null
    }

    function hasErrorForm() {
      let error = false
      // console.log(props.dataPagoConfig)
      if (
        props.dataPagoConfig.valor === '' ||
        props.dataPagoConfig.valor === 0 ||
        props.dataPagoConfig.valor === null
      ) {
        showMessageAlert('danger', 'Valor no debe ser vacío o cero')
        error = true
      } else if (props.dataPagoConfig.categoria === null) {
        showMessageAlert('danger', 'Debe seleccionar una categoria')
        error = true
      } else if (props.dataPagoConfig.formaPago === null) {
        showMessageAlert('danger', 'Debe seleccionar una forma pago')
        error = true
      }
      return error
    }
    async function uploadNoticia() {
      // console.log(props.dataPagoConfig)
      if (!hasErrorForm()) {
        showLoading.value = true
        const archivo = new FormData()
        archivo.append('valor', props.dataPagoConfig.valor)
        archivo.append('id_campeonato', props.dataPagoConfig.id_campeonato)
        archivo.append('id_categoria', props.dataPagoConfig.categoria.value)
        archivo.append('id_forma', props.dataPagoConfig.formaPago.value)
        const path = 'ApiConfiguration/saveConfigPago'
        const response = await postApiFormData(URL, path, archivo)
        if (response.flag === 'si') {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'GUARDADA con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            }
          )
          emit('recargar')
          resetForm()
        } else {
          showMessageAlert(
            'danger',
            // eslint-disable-next-line
            response.mensaje
          )
        }
        showLoading.value = false
      }
    }

    function onlyClose() {
      //   store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
      showLoading.value = false
    }
    return {
      tieneErrorTitulo,
      mensajeErrorTitulo,
      inputTitulo,
      uploadNoticia,
      selected,
      croppaFoto,
      file,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      messageError,
      variante,
      showLoading,
      hasError,
      showMessageAlert,
      dataNoticia,
      onlyClose,
      fileModel,
      USER,
      ROLES,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
